<section class="metric-tile h-100 d-flex flex-column gap-2 p-3">
  <div class="d-flex align-items-start justify-content-between gap-2">
    <span class="metric-label">{{ label() }}</span>

    <mat-icon class="metric-icon" aria-hidden="true">{{ icon() }}</mat-icon>
  </div>

  @switch (state()) {
    @case ('ready') {
      <span class="metric-value">{{ value() }}</span>

      @if (caption()) {
        <span class="metric-caption">{{ caption() }}</span>
      }
    }
    @case ('loading') {
      <span class="metric-placeholder" aria-live="polite">{{
        'backoffice.dashboard.metric.loading' | translate
      }}</span>
    }
    @case ('error') {
      <span class="metric-placeholder tone-error">{{
        'backoffice.dashboard.metric.error' | translate
      }}</span>
    }
    @case ('restricted') {
      <span class="metric-placeholder">{{
        'backoffice.dashboard.metric.restricted' | translate
      }}</span>
    }
    @default {
      <span class="metric-placeholder">{{
        'backoffice.dashboard.metric.uncomputed' | translate
      }}</span>
    }
  }

  @if (note()) {
    <span class="metric-note">{{ note() }}</span>
  }

  @if (source()) {
    <span
      class="metric-source"
      [matTooltip]="'backoffice.dashboard.metric.source_tooltip' | translate: { source: source() }"
      >{{ source() }}</span
    >
  }
</section>
